// src/components/UI/UserCard/utils/cardFormatters.js

export const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return 'сегодня';
    if (diffDays === 1) return 'вчера';
    if (diffDays < 7) return `${diffDays}д`;
    return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
  } catch {
    return '';
  }
};

export const formatTooltipText = (user, ratingInfo, userRoles) => {
  // Создаем строку с ролями без JSX
  const roleText = userRoles.length > 0
    ? userRoles.map(r => {
        // Получаем иконку как строку, а не как React компонент
        let icon = '';
        switch (r.type) {
          case 'legend': icon = '🏆'; break;
          case 'superuser': icon = '👑'; break;
          case 'moderator': icon = '🛡️'; break;
          case 'librarian': icon = '📚'; break;
          case 'donor': icon = '💰'; break;
          default: icon = '✨';
        }
        return `${icon} ${r.name}`;
      }).join(' • ')
    : 'Без особых ролей';

  // Формируем строки для тултипа (только текст, без JSX)
  const stats = `${ratingInfo.label} • Рейтинг: ${user?.rating || 0}\nИгр: ${user?.games_completed || 0}\nЧелленджей: ${user?.challenges_completed || 0}`;

  const bio = `${roleText}\n${user?.bio?.slice(0, 60) || 'Нет описания'}`;

  return {
    title: user.display_name || user.username || 'Пользователь',
    stats: stats,
    bio: bio
  };
};